<template>
  <div>
    <!-- ICMS GRUPO -->
    <div v-if="tipo == 'grouped' && !id_monitoria">
      <img
        v-if="isItMonitoredICMSGroup(produto) == 2"
        src="../../assets/images/icone-bell-2.png"
        class="monitoria-sim"
      />
      <img
        v-else-if="isItMonitoredICMSGroup(produto) == 1"
        src="../../assets/images/icone-bell-1.png"
        class="monitoria-nao"
        v-b-tooltip.hover.window
        title="Não Monitorado"
      />
      <img v-else src="../../assets/images/icone-bell-3.png" class="Parcialmente monitorado monitoria-nao" />
    </div>
    <!-- ICMS GRUPO -->

    <!--  GRUPO -->
    <div v-if="tipo == 'grouped' && id_monitoria">
      <img
        v-if="isItMonitoredGroup(produto, id_monitoria) == 2"
        src="../../assets/images/icone-bell-2.png"
        class="monitoria-sim"
      />
      <img
        v-else-if="isItMonitoredGroup(produto, id_monitoria) == 1"
        src="../../assets/images/icone-bell-3.png"
        class="monitoria-nao"
      />
      <img
        v-else
        src="../../assets/images/icone-bell-1.png"
        class="monitoria-nao"
        v-b-tooltip.hover.window
        title="Não Monitorado"
      />
    </div>
    <!--  GRUPO -->

    <!-- ICMS SINGLE -->
    <div v-if="tipo == 'single' && !id_monitoria">
      <img
        v-if="isItMonitoredICMS(produto) == 2"
        src="../../assets/images/icone-bell-2.png"
        class="monitoria-sim"
        v-b-tooltip.hover.window.html="tipMethod(produto.data_monitoramento, '1')"
      />
      <img
        v-else-if="isItMonitoredICMS(produto) == 1"
        src="../../assets/images/icone-bell-3.png"
        class="monitoria-nao"
        v-b-tooltip.hover.window.html="tipMethod(produto.data_monitoramento, '1')"
      />
      <img
        v-else
        src="../../assets/images/icone-bell-1.png"
        class="monitoria-nao"
        v-b-tooltip.hover.window
        title="Não Monitorado"
      />
    </div>
    <!-- ICMS SINGLE -->

    <div v-if="tipo == 'single' && id_monitoria">
      <img
        v-if="isItMonitored(produto, id_monitoria)"
        src="../../assets/images/icone-bell-2.png"
        class="monitoria-sim"
        v-b-tooltip.window.hover.html="tipMethod(produto.data_monitoramento, id_monitoria)"
      />

      <img
        v-else
        src="../../assets/images/icone-bell-1.png"
        class="monitoria-nao"
        v-b-tooltip.hover.window
        title="Não Monitorado"
      />
    </div>
  </div>
</template>

<script>
import dateFormatMixin from "@/mixins/dateFormatMixin";

export default {
  mixins: [dateFormatMixin],
  name: "SinosMonitoramento",
  props: {
    tipo: String,
    produto: {},
    id_monitoria: String
  },
  data() {
    return {};
  },
  mounted() {},
  watch: {},
  computed: {},

  methods: {
    isItMonitoredICMSGroup(group) {
      let monitored = -1;
      // 1 = não monitorado
      // 0 = parcialmente monitorado
      // 2 = completamente monitorado
      // group.filter()

      if (group.filter(f => f.icms_estado.length == 27).length == group.length) {
        monitored = 2;
      } else if (group.some(s => s.icms_estado.length >= 1)) {
        monitored = 0;
      } else {
        monitored = 1;
      }
      return monitored;
    },

    isItMonitoredICMS(item) {
      let monitored = -1;
      // 0 = não monitorado
      // 1 = parcialmente monitorado
      // 2 = completamente monitorado

      let currentMonitored = -1;
      if (item.icms_estado.length > 0 && item.icms_estado.length < 27) {
        currentMonitored = 1;
      } else if (item.icms_estado.length == 27) {
        currentMonitored = 2;
      } else {
        currentMonitored = 0;
      }
      if (currentMonitored > monitored) {
        monitored = currentMonitored; // atualiza monitored se o valor atual for maior
      }

      return monitored;
    },

    isItMonitoredGroup(group, id) {
      // 0 = não monitorado
      // 1 = parcialmente monitorado
      // 2 = completamente monitorado
      let contador = 0;
      let monitorado = 1;

      group.forEach(function(item) {
        if (item.id_tipo_monitoria.includes(id)) {
          contador++;
        }
      });

      if (contador == group.length && contador != 0) {
        monitorado = 2;
      } else if (contador < group.length && contador != 0) {
        monitorado = 1;
      } else {
        monitorado = 0;
      }

      return monitorado;
    },
    isItMonitored(produto, id) {
      let found = false;
      if (produto.id_tipo_monitoria.includes(id)) {
        found = true;
      }

      return found;
    },
    tipMethodGroup: function(group, index, id) {
      const groupedItems = this.groupedItems[group];

      if (!groupedItems[index]) {
        return;
      }

      let found = groupedItems[index].data_monitoramento.find(
        monitoria => monitoria.id_tipo_monitoria == id
      );
      if (!found) return;
      let data = found.created_at;

      return "<p>Data de cadastro: " + this.formatDateHour(data) + "</p>";
    },

    tipMethod: function(monitoramento, id) {
      // if(!this.arProduto[index]) return
      let found = monitoramento.find(monitoria => monitoria.id_tipo_monitoria == id);
      if (!found) return;
      let data = found.created_at;

      return "<p>Data de cadastro: " + this.formatDateHour(data) + "</p>";
    }
  }
};
</script>

<style lang="scss" scoped></style>
